/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';
import { ProblemInternalServerErrorType } from './ProblemInternalServerErrorType';

export const ProblemInternalServerError: core.serialization.ObjectSchema<
    serializers.ProblemInternalServerError.Raw,
    Truvity.ProblemInternalServerError
> = core.serialization.object({
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    instance: core.serialization.string().optional(),
    status: core.serialization.number(),
    title: core.serialization.string(),
    type: ProblemInternalServerErrorType,
});

export declare namespace ProblemInternalServerError {
    export interface Raw {
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        instance?: string | null;
        status: number;
        title: string;
        type: ProblemInternalServerErrorType.Raw;
    }
}
